// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ProfileHeader.module.css */
.MyFollowing_container__pAWY7 {
    width: 100%;
    min-height: 100vh;
    background-color: #121212;
    color: white;
    font-family: Arial, sans-serif;
  }
  
  .MyFollowing_profileSection__qzjUc {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 2rem;
  }
  
  .MyFollowing_profilePicture__63MF3 {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    background-color: #ff0000;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 1rem;
    transition: transform 0.3s ease;
  }
  
  .MyFollowing_profilePicture__63MF3:hover {
    transform: scale(1.05);
    box-shadow: 0 0 15px rgba(255, 0, 0, 0.5);
  }
  
  .MyFollowing_userIcon__28VBN {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .MyFollowing_profileName__MXpfD {
    font-size: 1.8rem;
    margin-bottom: 2rem;
    font-weight: bold;
  }
  
  .MyFollowing_searchBar__KjH-W {
    position: relative;
    width: 100%;
    max-width: 600px;
    margin-bottom: 3rem;
  }
  
  .MyFollowing_searchInput__YiyR0 {
    width: 100%;
    padding: 1rem 0.2rem;
    border-radius: 50px;
    border: none;
    background-color: #333;
    color: white;
    font-weight: 600;
    transition: all 0.3s ease;
  }
  
  .MyFollowing_searchInput__YiyR0:hover, .MyFollowing_searchInput__YiyR0:focus {
    background-color: #444;
    outline: none;
    box-shadow: 0 0 8px rgba(255, 255, 255, 0.2);
  }
  
  .MyFollowing_searchButton__9UX8j {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    cursor: pointer;
    transition: transform 0.2s ease;
  }
  
  .MyFollowing_searchButton__9UX8j:hover {
    transform: translateY(-50%) scale(1.1);
  }
  
  .MyFollowing_authorGrid__31p7n {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;
    width: 100%;
  }
  
  .MyFollowing_authorCard__yNorX {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1rem;
    background-color: #1e1e1e;
    border-radius: 8px;
    transition: all 0.3s ease;
  }
  
  .MyFollowing_authorCard__yNorX:hover {
    background-color: #2a2a2a;
    transform: translateY(-3px);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
    border: 1px solid red;
  }
  
  .MyFollowing_authorImg__6O7I9 {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    overflow: hidden;
    background-color: #444;
    transition: transform 0.3s ease;
  }
  
  .MyFollowing_authorCard__yNorX:hover .MyFollowing_authorImg__6O7I9 {
    transform: scale(1.08);
  }
  
  .MyFollowing_authorImg__6O7I9 img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  
  .MyFollowing_authorName__FjeSb {
    flex-grow: 1;
    margin-left: 1rem;
    font-weight: bold;
  }
  
  .MyFollowing_unfollowButton__MrMcD {
    background-color: #0f700e;
    color: white;
    border: none;
    border-radius: 50px;
    padding: 0.5rem 1rem;
    cursor: pointer;
    font-weight: bold;
    transition: all 0.3s ease;
  }
  
  .MyFollowing_unfollowButton__MrMcD:hover {
    background-color: #158814;
    transform: scale(1.05);
    box-shadow: 0 0 8px rgba(15, 112, 14, 0.5);
  }
  .MyFollowing_noResults__fZDDE{
    position: absolute;
    left: 55%;
  }
  
  /* Responsive adjustments */
  @media (max-width: 768px) {
    .MyFollowing_header__XF\\+Ma {
      flex-direction: column;
      gap: 1rem;
    }
    
    .MyFollowing_navigation__173yW ul {
      gap: 1rem;
    }
    
    .MyFollowing_authorGrid__31p7n {
      grid-template-columns: 1fr;
    }
  }`, "",{"version":3,"sources":["webpack://./src/admin/pages/Following/MyFollowing.module.css"],"names":[],"mappings":"AAAA,6BAA6B;AAC7B;IACI,WAAW;IACX,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,8BAA8B;EAChC;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,+BAA+B;EACjC;;EAEA;IACE,sBAAsB;IACtB,yCAAyC;EAC3C;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;IACZ,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;IACtB,aAAa;IACb,4CAA4C;EAC9C;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,+BAA+B;EACjC;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,WAAW;EACb;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,2BAA2B;IAC3B,yCAAyC;IACzC,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,+BAA+B;EACjC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,oBAAoB;IACpB,eAAe;IACf,iBAAiB;IACjB,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,sBAAsB;IACtB,0CAA0C;EAC5C;EACA;IACE,kBAAkB;IAClB,SAAS;EACX;;EAEA,2BAA2B;EAC3B;IACE;MACE,sBAAsB;MACtB,SAAS;IACX;;IAEA;MACE,SAAS;IACX;;IAEA;MACE,0BAA0B;IAC5B;EACF","sourcesContent":["/* ProfileHeader.module.css */\n.container {\n    width: 100%;\n    min-height: 100vh;\n    background-color: #121212;\n    color: white;\n    font-family: Arial, sans-serif;\n  }\n  \n  .profileSection {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 2rem;\n  }\n  \n  .profilePicture {\n    width: 100px;\n    height: 100px;\n    border-radius: 50%;\n    background-color: #ff0000;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 1rem;\n    transition: transform 0.3s ease;\n  }\n  \n  .profilePicture:hover {\n    transform: scale(1.05);\n    box-shadow: 0 0 15px rgba(255, 0, 0, 0.5);\n  }\n  \n  .userIcon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  \n  .profileName {\n    font-size: 1.8rem;\n    margin-bottom: 2rem;\n    font-weight: bold;\n  }\n  \n  .searchBar {\n    position: relative;\n    width: 100%;\n    max-width: 600px;\n    margin-bottom: 3rem;\n  }\n  \n  .searchInput {\n    width: 100%;\n    padding: 1rem 0.2rem;\n    border-radius: 50px;\n    border: none;\n    background-color: #333;\n    color: white;\n    font-weight: 600;\n    transition: all 0.3s ease;\n  }\n  \n  .searchInput:hover, .searchInput:focus {\n    background-color: #444;\n    outline: none;\n    box-shadow: 0 0 8px rgba(255, 255, 255, 0.2);\n  }\n  \n  .searchButton {\n    position: absolute;\n    right: 10px;\n    top: 50%;\n    transform: translateY(-50%);\n    background: none;\n    border: none;\n    cursor: pointer;\n    transition: transform 0.2s ease;\n  }\n  \n  .searchButton:hover {\n    transform: translateY(-50%) scale(1.1);\n  }\n  \n  .authorGrid {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 1rem;\n    width: 100%;\n  }\n  \n  .authorCard {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 1rem;\n    background-color: #1e1e1e;\n    border-radius: 8px;\n    transition: all 0.3s ease;\n  }\n  \n  .authorCard:hover {\n    background-color: #2a2a2a;\n    transform: translateY(-3px);\n    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);\n    border: 1px solid red;\n  }\n  \n  .authorImg {\n    width: 50px;\n    height: 50px;\n    border-radius: 50%;\n    overflow: hidden;\n    background-color: #444;\n    transition: transform 0.3s ease;\n  }\n  \n  .authorCard:hover .authorImg {\n    transform: scale(1.08);\n  }\n  \n  .authorImg img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n  \n  .authorName {\n    flex-grow: 1;\n    margin-left: 1rem;\n    font-weight: bold;\n  }\n  \n  .unfollowButton {\n    background-color: #0f700e;\n    color: white;\n    border: none;\n    border-radius: 50px;\n    padding: 0.5rem 1rem;\n    cursor: pointer;\n    font-weight: bold;\n    transition: all 0.3s ease;\n  }\n  \n  .unfollowButton:hover {\n    background-color: #158814;\n    transform: scale(1.05);\n    box-shadow: 0 0 8px rgba(15, 112, 14, 0.5);\n  }\n  .noResults{\n    position: absolute;\n    left: 55%;\n  }\n  \n  /* Responsive adjustments */\n  @media (max-width: 768px) {\n    .header {\n      flex-direction: column;\n      gap: 1rem;\n    }\n    \n    .navigation ul {\n      gap: 1rem;\n    }\n    \n    .authorGrid {\n      grid-template-columns: 1fr;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `MyFollowing_container__pAWY7`,
	"profileSection": `MyFollowing_profileSection__qzjUc`,
	"profilePicture": `MyFollowing_profilePicture__63MF3`,
	"userIcon": `MyFollowing_userIcon__28VBN`,
	"profileName": `MyFollowing_profileName__MXpfD`,
	"searchBar": `MyFollowing_searchBar__KjH-W`,
	"searchInput": `MyFollowing_searchInput__YiyR0`,
	"searchButton": `MyFollowing_searchButton__9UX8j`,
	"authorGrid": `MyFollowing_authorGrid__31p7n`,
	"authorCard": `MyFollowing_authorCard__yNorX`,
	"authorImg": `MyFollowing_authorImg__6O7I9`,
	"authorName": `MyFollowing_authorName__FjeSb`,
	"unfollowButton": `MyFollowing_unfollowButton__MrMcD`,
	"noResults": `MyFollowing_noResults__fZDDE`,
	"header": `MyFollowing_header__XF+Ma`,
	"navigation": `MyFollowing_navigation__173yW`
};
export default ___CSS_LOADER_EXPORT___;
